import { render, staticRenderFns } from "./myServer.vue?vue&type=template&id=0e823234&scoped=true"
import script from "./myServer.vue?vue&type=script&lang=js"
export * from "./myServer.vue?vue&type=script&lang=js"
import style0 from "./myServer.vue?vue&type=style&index=0&id=0e823234&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e823234",
  null
  
)

export default component.exports